<template lang="pug">
  .component-client-controller
    .row
      .columns.small-12.large-6
        driver(:type="'driver-card'", :item="item.main_driver")
    .row.column
      .card.p-1
        router-view
</template>
<script type="text/babel">
  import RouterTabHeaders from 'components/structure/foundation/RouterTabHeaders'
  import Driver from 'components/backoffice/Driver'
  import Client from 'components/backoffice/Client'
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import Cards from '../../../components/structure/Cards'
  import LoadingSpinner from '../../../components/structure/LoadingSpinner'
  import Card3 from "../../../components/structure/Card3";

  export default {
    name: 'ClientCreditNoteController',
    components: {
      Card3,
      LoadingSpinner,
      Cards,
      Client,
      Driver,
      RouterTabHeaders
    },
    data() {
      return {

      }

    },
    mounted() {
    },

    created() {

    },
    methods: {

    },
    computed: {

    },
    props: ['item'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">

  .columnizer
    padding-left: 20px

  .columnizer > div
    margin-bottom: 10px

  .columnizer span
    text-transform: capitalize
    color: #626262

  .columnizer > div > span
      text-transform: uppercase
      font-weight: bold
      color: #5EB9CF

  .client-subscriptions
    margin: 10px

    .client-reservations
      margin: 10px

    .client-profile
      margin: 20px

    .client-drivers
      margin: 20px

</style>



// WEBPACK FOOTER //
// ClientCreditNote.vue?6b2ba8c0